import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout file for /setup/ratecards/* — exists so the index route (the summary
// list) and the $id route (the detail) can both nest under a common parent.
// Currently no shared chrome; just renders the matched child.
export const Route = createFileRoute('/_authenticated/setup/ratecards')({
  component: () => <Outlet />,
});
